import React, { useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

const FileDropZone = ({
  onFiles,
  accept,
  multiple,
  disabled,
  inputLabel,
  children,
}) => {
  const inputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const emitFiles = useCallback((fileList) => {
    const files = Array.from(fileList || []);
    if (files.length) {
      onFiles(files);
    }
  }, [onFiles]);

  const open = useCallback(() => {
    if (!disabled && inputRef.current) {
      inputRef.current.click();
    }
  }, [disabled]);

  const handleInputChange = (event) => {
    emitFiles(event.target.files);
  };

  const handleDragOver = (event) => {
    if (disabled) {
      return;
    }
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => setIsDragging(false);

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    if (disabled) {
      return;
    }
    if (event.dataTransfer && event.dataTransfer.files) {
      emitFiles(event.dataTransfer.files);
    }
  };

  const dropzoneProps = {
    onDragOver: handleDragOver,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop,
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        hidden
        // Names the hidden input for assistive tech, and lets tests find it by label.
        aria-label={inputLabel}
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={handleInputChange}
        // Clear the value so re-selecting the same file still fires onChange.
        onClick={(event) => {
          // eslint-disable-next-line no-param-reassign
          event.target.value = '';
        }}
      />
      {children({ isDragging, dropzoneProps, open })}
    </>
  );
};

FileDropZone.propTypes = {
  onFiles: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
  accept: PropTypes.string,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  inputLabel: PropTypes.string,
};

FileDropZone.defaultProps = {
  accept: undefined,
  multiple: false,
  disabled: false,
  inputLabel: undefined,
};

export default FileDropZone;
